export const CREATE_GENERAL_REQUEST = "CREATE_GENERAL_REQUEST";
export const FETCH_GENERAL_REQUESTS = "FETCH_GENERAL_REQUESTS";
export const FETCH_GENERAL_REQUEST = "FETCH_GENERAL_REQUEST";
export const EDIT_GENERAL_REQUEST = "EDIT_GENERAL_REQUEST";
export const DELETE_GENERAL_REQUEST = "DELETE_GENERAL_REQUEST";
